import React from 'react'
import { ToggleSwitchProps } from './ToggleSwitch.types'
import './ToggleSwitch.styles.css'

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  options,
  value,
  onChange,
  size = 'medium',
  colorScheme = 'default',
  leftColor,
  rightColor,
  className = '',
  disabled = false,
  fullWidth = false,
  'aria-label': ariaLabel,
}) => {
  const [option1, option2] = options
  const activeIndex = value === option1.value ? 0 : 1

  const handleOptionClick = (optionValue: string) => {
    if (!disabled && optionValue !== value) {
      onChange(optionValue)
    }
  }

  const toggleClasses = [
    'toggle-switch',
    `toggle-switch--${size}`,
    `toggle-switch--${colorScheme}`,
    fullWidth && 'toggle-switch--full-width',
    disabled && 'toggle-switch--disabled',
    className
  ].filter(Boolean).join(' ')

  const customStyles = colorScheme === 'custom' ? {
    '--toggle-left-color': leftColor || '#ef5343',
    '--toggle-right-color': rightColor || '#002035',
  } as React.CSSProperties : {}

  return (
    <div 
      className={toggleClasses}
      data-active-index={activeIndex}
      style={customStyles}
      role="tablist"
      aria-label={ariaLabel}
    >
      <button
        className={`toggle-option ${value === option1.value ? 'toggle-option--active' : ''}`}
        onClick={() => handleOptionClick(option1.value)}
        disabled={disabled}
        role="tab"
        aria-selected={value === option1.value}
        aria-controls={`panel-${option1.value}`}
        id={`tab-${option1.value}`}
        tabIndex={value === option1.value ? 0 : -1}
      >
        {option1.icon && <span className="toggle-icon">{option1.icon}</span>}
        <span className="toggle-label">{option1.label}</span>
      </button>
      
      <button
        className={`toggle-option ${value === option2.value ? 'toggle-option--active' : ''}`}
        onClick={() => handleOptionClick(option2.value)}
        disabled={disabled}
        role="tab"
        aria-selected={value === option2.value}
        aria-controls={`panel-${option2.value}`}
        id={`tab-${option2.value}`}
        tabIndex={value === option2.value ? 0 : -1}
      >
        {option2.icon && <span className="toggle-icon">{option2.icon}</span>}
        <span className="toggle-label">{option2.label}</span>
      </button>
    </div>
  )
}

// Export default for backward compatibility
export default ToggleSwitch